import React from 'react'
import { ModuleHeader } from '../module-header'
import { StyledFinishedExamsCardWrapper } from './created-exams.style'
import CreatedExamsItem from './created-exams-item'

const CreatedExams = () => {
    const isAssignment = window.location.pathname.includes('assignments')
    return (
        <>
            <ModuleHeader title={!isAssignment ? "Created EXAMS" : "Created assignments"} />
            <StyledFinishedExamsCardWrapper>
                <CreatedExamsItem />
                <CreatedExamsItem />
                <CreatedExamsItem isDeployed />
            </StyledFinishedExamsCardWrapper>
        </>
    )
}

export { CreatedExams }
